// #region IMPORTS
import PropTypes from 'prop-types';
import React from 'react';
// CSS
import './Tooltip.css';
// #endregion

// #region TYPES
/**
 * Props of the Tooltip component.
 * @typedef {Object} TooltipProps
 * @property {import('react').ReactNode} [children] The content of the tooltip
 */
// #endregion

// #region COMPONENT
// Hover label, positioned and revealed by the consumer's contextual CSS.
/** @param {TooltipProps} props */
const Tooltip = ({ children }) => <div className="Tooltip">{children}</div>;
// #endregion

// #region PROPERTIES
Tooltip.propTypes = {
  children: PropTypes.node,
};
// #endregion

export { Tooltip };
